import { render, staticRenderFns } from "./return-appraise.vue?vue&type=template&id=6534d6d4&scoped=true&"
import script from "./return-appraise.vue?vue&type=script&lang=ts&"
export * from "./return-appraise.vue?vue&type=script&lang=ts&"
import style0 from "./return-appraise.vue?vue&type=style&index=0&id=6534d6d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6534d6d4",
  null
  
)

export default component.exports